import type { ReactNode, RefObject } from "react";
import { QRCodeSVG } from "qrcode.react";
import {
  ModalFooter,
  ModalShell,
  type ModalFooterButton,
} from "../ui/modal";

interface PersistentQrModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  url: string | null;
  qrRef?: RefObject<HTMLDivElement | null>;
  unavailableMessage?: ReactNode;
  actions?: ModalFooterButton[];
  confirmLabel?: string;
  onConfirm?: () => void | Promise<void>;
  confirmDisabled?: boolean;
  /** 신청서처럼 z-100000 모달 안에서 열 때만 한 층 위로 올린다. */
  layer?: "base" | "elevated";
  /** 부모 모달과 겹치는 자리에서는 Esc가 최상단 QR 창만 닫히게 한다. */
  escMode?: "direct" | "stack";
}

// 매장에 오래 두는 고정 주소용 공용 창. 매장 입력 QR과 태블릿 연결 QR이 같은 QR·주소·
// 푸터 골격을 공유하고, 출력/복사 같은 목적별 동작만 actions/confirm으로 갈라 끼운다.
export default function PersistentQrModal({
  isOpen,
  onClose,
  title,
  subtitle,
  url,
  qrRef,
  unavailableMessage,
  actions = [],
  confirmLabel,
  onConfirm,
  confirmDisabled,
  layer = "base",
  escMode = "direct",
}: PersistentQrModalProps) {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      size="sm"
      layer={layer}
      escMode={escMode}
      footer={
        <ModalFooter
          onCancel={onClose}
          cancelLabel="닫기"
          extraActions={actions}
          confirmLabel={confirmLabel}
          onConfirm={onConfirm}
          confirmDisabled={confirmDisabled}
        />
      }
    >
      <div className="flex flex-col items-center gap-4 py-2">
        {url ? (
          <>
            <div
              ref={qrRef}
              className="rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700"
            >
              <QRCodeSVG value={url} size={220} level="M" />
            </div>
            <p className="max-w-xs break-all text-center text-[11px] text-gray-400">
              {url}
            </p>
          </>
        ) : (
          unavailableMessage ?? (
            <p className="max-w-xs text-center text-sm text-gray-500">
              주소를 불러오지 못했습니다.
            </p>
          )
        )}
      </div>
    </ModalShell>
  );
}
